import React from 'react';

interface LogoSpinnerProps {
  size?: number;
  text?: string;
}

const LogoSpinner: React.FC<LogoSpinnerProps> = ({ size = 60, text }) => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh', backgroundColor: 'var(--vz-body-bg)' }}>
      <div className="text-center">
        <img 
          src="/assets/images/space_logo_final_centered.svg" 
          alt="Loading..." 
          className="logo-spinner"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            marginBottom: '1rem'
          }}
        />
        {text && <p className="text-muted">{text}</p>}
      </div>
    </div>
  );
};

export default LogoSpinner;
